exports.Company = require('./CompanySchema');
exports.User = require('./UserSchema');
exports.Signup = require('./SignupSchema');
exports.Settings = require("./Settings");


// WEBPACK FOOTER //
// ./schemas/account/index.js